export const componentsTranslations = {
  pt: {
    pageCard: {
      untitled: "Sem título",
      accessesToday: "acessos hoje",
      viewDetails: "Ver detalhes",
      visit: "Visitar"
    },
    pageDetails: {
      loading: "Carregando informações da página...",
      notFound: "Página não encontrada",
      backToHome: "Voltar para o início",
      pageInfo: "Informações da página",
      openPage: "Abrir página",
      editPage: "Editar página",
      accessToday: "acesso hoje",
      accessesToday: "acessos hoje",
      description: "Descrição",
      address: "Endereço",
      lastUpdate: "Última atualização",
      never: "Nunca",
      accessesInPeriod: "Acessos nos últimos {period}",
      total: "Total ({period})",
      dailyAverage: "Média diária",
      monthlyAverage: "Média mensal",
      today: "Hoje",
      periods: {
        "7d": "7 dias",
        "15d": "15 dias",
        "30d": "30 dias",
        "6m": "6 meses",
        "1y": "1 ano"
      }
    }
  },
  en: {
    pageCard: {
      untitled: "Untitled",
      accessesToday: "accesses today",
      viewDetails: "View details",
      visit: "Visit"
    },
    pageDetails: {
      loading: "Loading page information...",
      notFound: "Page not found",
      backToHome: "Back to home",
      pageInfo: "Page information",
      openPage: "Open page",
      editPage: "Edit page",
      accessToday: "access today",
      accessesToday: "accesses today",
      description: "Description",
      address: "Address",
      lastUpdate: "Last update",
      never: "Never",
      accessesInPeriod: "Accesses in the last {period}",
      total: "Total ({period})",
      dailyAverage: "Daily average",
      monthlyAverage: "Monthly average",
      today: "Today",
      periods: {
        "7d": "7 days",
        "15d": "15 days",
        "30d": "30 days",
        "6m": "6 months",
        "1y": "1 year"
      }
    }
  }
};
